<template>
  <navbar>
    <my-button @click="log_out()">log out</my-button>
  </navbar>

  <div class="head">
    <div class="username">{{ username }}</div>
    <div v-if="isBarman" class="barman">
      <my-button @click="$router.push('/barman')">Barman</my-button>
      <my-button @click="$router.push('/barman/cocktails')">Cocktails</my-button>
      <my-button @click="$router.push('/top')">Top</my-button>
    </div>
  </div>

  <div class="orders">
    <div style="font-size: 75px; text-align: center;">Order</div>
    <div class="border">
      <!-- <div v-for="order in user_order.filter((order) => order.status != 'history')"> -->
      <!-- <div class="cocktail" v-for="order in user_order" -->
      <div class="cocktail" v-for="order in user_order.filter(order => order.status != 'history')"
        :class="{
          'border_gray': order.status == 'ordering', 'border_cook': order.status == 'cook',
          'border_ready': order.status == 'ready', 'border_history': order.status == 'history'
        }"
      >
        <div>
          <img style="height: 150px;" src="/api/static/icons/cocktail (20231105111207).png"></img>
        </div>
        <div>
          <div class="name">{{ order.name }}
            <div class="alc" v-if="order.alcohols">Alc</div>
          </div>
          <div>статус: {{ order.status }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="orders">
    <div style="font-size: 75px; text-align: center;">History</div>
    <div class="border">
      <div class="cocktail" v-for="order in user_order.filter(order => order.status == 'history')"
        :class="{'border_history': order.status == 'history'}"
      >
        <div>
          <img style="height: 150px;" src="/api/static/icons/cocktail (20231105111207).png"></img>
        </div>
        <div>
          <div class="name">{{ order.name }}
            <div class="alc" v-if="order.alcohols">Alc</div>
          </div>
          <div>статус: {{ order.status }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="orders">
    <div style="font-size: 75px; text-align: center;">Выпито</div>
    <div class="border">
      <div class="line" v-for="stat in order_statistic">
        <div>{{ stat[0] }}</div>
        <div>{{ stat[1] }}</div>
      </div>
    </div>
  </div>
</template>


<script>
import Navbar from '@/components/Navbar.vue';
// import ky from 'ky';

export default {
  components: {
    Navbar
  },
  data() {
    return {
      username: '',
      isBarman: false,
      user_order: [],
      order_statistic: [],
    }
  },
  methods: {
    async log_out() {
      let res = await fetch('/api/auth/log_out', {
        method: "POST",
        headers: {"content-type": "application/json"},
      })
      if (res.status === 200) {
        // let data = await res.json();
        this.$router.push('/auth/log_in');
      }
    },
    async get_order() {
      let res = await fetch('/api/profile', {
        method: "POST",
        headers: {"content-type": "application/json"},
      })
      if (res.status === 200) {
        let data = await res.json();
        // console.log(data);
        this.username = data['username'];
        this.isBarman = data['isBarman'];
        this.user_order = data['user_order'];
        this.order_statistic = data['order_statistic'];
      }
    },
    async isauth() {
      let res = await fetch('/api/auth/isauth', {
        method: "POST",
        headers: {"content-type": "application/json"},
      });
      if (res.status === 200) {
        let data = await res.json();
        // console.log(data['auth']);
        if (!data['auth']) {
          this.$router.push('/auth/log_in');
        }
      }
    }
  },
  mounted() {
    this.isauth();
    this.get_order();
  }
}
</script>


<style scoped>
.head {
  margin-top: 50px;
}
.username {
  font-size: 75px;
  text-align: center;
}

.barman {
  display: flex;
  flex-direction: column;
  /* flex-direction: row; */
  /* gap: 10px; */
  /* justify-content: center; */
  /* justify-items: center; */
  /* justify-self: center; */
  /* text-align: center; */
  width: max-content;
  margin: auto;
}

.orders {
  /* text-align: center; */

  margin: 15px;
  margin-top: 75px;
  /* padding: 35px; */
  margin-bottom: 100px;
}
.border {
  display: flex;
  flex-direction: column;
  gap: 10px;

  border: 6px solid var(--bar-color-main);
  padding: 15px;
  border-radius: 15px;

  max-height: 500px;
  overflow-y: scroll;
}

.cocktail {
  display: flex;
  /* margin-top: 15px; */
  padding: 5px;
  border: 6px solid var(--bar-color-main);
  border-radius: 15px;
}
.border_gray {
  border: 5px solid gray;
}
.border_cook {
  border: 5px solid orange;
}
.border_ready {
  border: 5px solid lightgreen;
}
.border_history {
  /* border: 5px solid black; */
  border: 5px solid lightgreen;
}

.name {
  display: flex;
  color: black;
  font-size: 40px;
  padding: 25px;
  /* align-self: center; */
  /* align-content: center; */
  align-items: center;
}
.alc {
  margin-left: 25px;
  color: HotPink;
  font-size: 40px;
}

.line {
  display: flex;
  justify-content: space-between;
}
</style>
